import { render } from "./dx-loader.vue?vue&type=template&id=380a5480"
import script from "./dx-loader.vue?vue&type=script&setup=true&lang=js"
export * from "./dx-loader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/loader/dx-loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "380a5480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('380a5480', __exports__)) {
    api.reload('380a5480', __exports__)
  }
  
  module.hot.accept("./dx-loader.vue?vue&type=template&id=380a5480", () => {
    api.rerender('380a5480', render)
  })

}


export default __exports__